import sanitizeHTML from "sanitize-html";

const SANITIZE_OPTIONS: sanitizeHTML.IOptions = {
  allowedAttributes: {
    ...sanitizeHTML.defaults.allowedAttributes,
    "*": ["style", "align", "width", "height", "class", "id", "title"],
    a: ["href", "name", "target", "rel"],
    font: ["color", "bgcolor", "size", "face"],
    table: ["border", "cellpadding", "cellspacing", "summary"],
    td: ["colspan", "rowspan", "valign", "scope"],
    th: ["colspan", "rowspan", "valign", "scope"],
    tr: ["valign"],
    col: ["span"],
    colgroup: ["span"],
    ol: ["type", "start"],
    li: ["value"],
    button: ["type", "name", "value"],
    textarea: ["rows", "cols", "name", "placeholder"],
    label: ["for"],
    details: ["open"],
  },
  allowedSchemesByTag: {
    img: ["http", "https", "data"],
  },
};

export const sanitizeRichText = (html: string): string => {
  return sanitizeHTML(html, {
    ...SANITIZE_OPTIONS,
    allowedTags: sanitizeHTML.defaults.allowedTags.concat([
      "img",
      "del",
      "strike",
      "font",
      "details",
      "summary",
      "button",
      "col",
      "colgroup",
      "label",
      "textarea",
    ]),
  });
};

const normalizeHtml = (html: string): string => {
  return sanitizeHTML(html, {
    ...SANITIZE_OPTIONS,
    allowedTags: false,
  });
};

export const containsDisallowedTags = (html: string): boolean => {
  return sanitizeRichText(html) !== normalizeHtml(html);
};
